const getBarOptions = (style) => {
    let barWidth = 20,
        barBorderRadius = 4;
    if (style === 2) {
        barWidth = 14;
        barBorderRadius = [0, 100, 100, 0];
    }
    const chartOption = {
        textStyle: {
            fontFamily: 'font-normal',
            fontSize: 12
        },
        grid: {
            left: '5%',
            top: '12%',
            bottom: '12%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'value',
                show: false
            }
        ],
        yAxis: [
            {
                type: 'category',
                boundaryGap: true,
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                offset: 20
            }
        ],
        series: [
            {
                type: 'bar',
                barWidth: barWidth,
                cursor: 'default',
                itemStyle: {
                    normal: {
                        barBorderRadius: barBorderRadius
                    }
                }
            }
        ]
    };
    return chartOption;
};

export default getBarOptions;
